import { HttpContext } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { HttpService } from '../http/http.service';
import { Observable } from 'rxjs';
import { APP_CONFIG } from '../environment/environment.token';
import { INCLUDE_AUTH_TOKEN } from './api.tokens';

@Injectable({
  providedIn: 'root',
})
export class ApiService {
  private readonly config = inject(APP_CONFIG);
  private readonly http = inject(HttpService);

  private readonly API_URL = this.config.apiUrl;

  private addContextToRequest(needToken: boolean, reqOpts: object): object {
    if (needToken) {
      return {
        ...reqOpts,
        context: new HttpContext().set(INCLUDE_AUTH_TOKEN, true),
      };
    }
    return reqOpts;
  }

  // TODO refactor: arguments as a options object
  // use options (same structure as http methods) with 'superpowers' (new properties like needToken) or maybe customized object, i.e.:
  /*

interface GetOptions {
  needToken?: boolean;
  params?: any;
  reqOpts?: any;
}

get( endpoint: string , options: IRequestContentOptions = {} )

*/

  get(endpoint: string, params?: any, reqOpts?: any, needToken = true): Observable<ArrayBuffer> {
    if (params) {
      reqOpts = params;
    }
    reqOpts = this.addContextToRequest(needToken, reqOpts);
    return this.http.get(this.API_URL + endpoint, reqOpts);
  }

  post(endpoint: string, body: any, reqOpts?: any, needToken = true): Observable<ArrayBuffer> {
    reqOpts = this.addContextToRequest(needToken, reqOpts);
    return this.http.post(this.API_URL + endpoint, body, reqOpts);
  }

  put(endpoint: string, body: any, reqOpts?: any, needToken = true): Observable<ArrayBuffer> {
    reqOpts = this.addContextToRequest(needToken, reqOpts);
    return this.http.put(this.API_URL + endpoint, body, reqOpts);
  }

  delete(endpoint: string, reqOpts?: any, needToken = true): Observable<ArrayBuffer> {
    reqOpts = this.addContextToRequest(needToken, reqOpts);
    return this.http.delete(this.API_URL + endpoint, reqOpts);
  }

  patch(endpoint: string, body: any, reqOpts?: any, needToken = true): Observable<ArrayBuffer> {
    reqOpts = this.addContextToRequest(needToken, reqOpts);
    return this.http.patch(this.API_URL + endpoint, body, reqOpts);
  }
}
